import { Component } from "react";
import "./styles/PromineoSimpleDataGrid.css";
import { IDataGridOptions } from "devextreme-react/data-grid";
import PromineoBaseDataGrid, { GridOptions } from "./PromineoBaseDataGrid";

export default class PromineoSimpleDataGrid extends Component<GridOptions> {
  constructor(props: GridOptions) {
    super(props);
    this.state = {};
  }

  defaultGridOptions: IDataGridOptions = {
    showBorders: true,
    showRowLines: true,
    showColumnLines: true,
  };

  render() {
    const { children, gridRef, dataGridOptions } = this.props;
    return (
      <PromineoBaseDataGrid
        dataGridOptions={{ ...this.defaultGridOptions, ...dataGridOptions }}
        gridRef={gridRef}
        classNames={`promineo-simpleDatagrid ${this.props.classNames ?? ""}`}
      >
        {children}
      </PromineoBaseDataGrid>
    );
  }
}
